import { ScreenItem } from "../../dataTypes";

export class Module {

  protected ref: Phaser.GameObjects.Sprite | Phaser.GameObjects.Image;
  public data: ScreenItem; 

  constructor(ref:any, data:ScreenItem){
    this.ref = ref
    this.data = data;
    this.init();
  }

  init() {      
  }

}


